const mobileBreackpoint = 767;

const $main_grid_slider = $('.grid .row');
const settings_main_grid_slider = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  asNavFor: '.grid__mobile-tab',
  infinite: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        arrows: true,
      },
    },
  ],
}

const $nav_grid_slider = $('.grid__mobile-tab');
const settings_nav_grid_slider = {
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.grid .row',
  dots: false,
  centerMode: true,
  focusOnSelect: true,
  infinite: false,
}

slider_on_mobile($main_grid_slider, settings_main_grid_slider);
slider_on_mobile($nav_grid_slider, settings_nav_grid_slider);

function slider_on_mobile(slider, settings) {
  $(window).on('load resize', function () {
    if ($(window).width() > mobileBreackpoint) {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
      return
    }
    if (!slider.hasClass('slick-initialized')) {
      return slider.slick(settings);
    }
  })
}



// WEBPACK FOOTER //
// ./scripts/gutenberg_components/_grid.js